exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{background-color:#3f3d56;padding:40px 0;color:#fff}.footer .box{display:grid;grid-template-columns:auto 1fr 1fr;grid-column-gap:2rem;max-width:1200px;margin:0 auto}.footer svg{width:200px}.footer p{font-family:Lato,sans-serif;line-height:1.6em;font-weight:400;font-size:.8em}.decalement{margin-left:5%;margin-right:5%;line-height:2em}@media screen and (max-width:700px){.footer .box{display:grid;grid-template-columns:1fr;grid-row-gap:1rem;text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b4332d0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content/Footer.vue
// module id = 235
// module chunks = 0